export function dateToString(date, withTime) {
    var minute = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    var hour = (date.getHours() < 10 ? '0' : '') + date.getHours();
    var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
    var monthInt = parseInt(date.getMonth()) + 1;
    var month = (monthInt < 10 ? '0' : '') + monthInt;
    var year = date.getFullYear();

    if (withTime) {
        return day + "." + month + "." + year + " " + hour + ":" + minute;
    } else {
        return day + "." + month + "." + year;
    }
}
